import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
// eslint-disable-next-line no-restricted-imports
import { UntypedFormControl, NgForm, Validators } from '@angular/forms';
import { ApBaseComponent } from '../ap-base-component/index';
import { finalize, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'ap-numeric-up-down',
  templateUrl: 'ap-numeric-up-down.component.html',
  styleUrls: ['ap-numeric-up-down.component.less'],
})
export class ApNumericUpDownComponent extends ApBaseComponent implements OnInit {
  constructor() {
    super();
  }

  @Input() baseId?: string;
  @Input() initialValue = 50;
  @Input() minValue = -1;
  @Input() maxValue = 10000;
  @Input() required?: boolean;
  @Input() currentValueFormControl: UntypedFormControl;
  @Input() form?: NgForm;
  @Output() valueUpdated: EventEmitter<number | null> = new EventEmitter<number | null>();

  Id = '';
  emitNewValue = false;

  ngOnInit() {
    this.setId();
    this.setupFormControl();
  }

  private setupFormControl() {
    if (!this.currentValueFormControl) {
      this.currentValueFormControl = new UntypedFormControl('');
      this.currentValueFormControl.setValue(this.initialValue);
      if (this.isRequired()) {
        this.currentValueFormControl.setValidators([Validators.required]);
      }
      this.emitNewValue = true;
    }

    this.currentValueFormControl.valueChanges.pipe(
      finalize(() => { /* */} ),
      takeUntil(this.onDestroy$),
    ).subscribe(
      (newValue: number | null) => {
        if (newValue != null) {
          if (newValue > this.maxValue) {
            newValue = this.maxValue;
            this.currentValueFormControl.setValue(newValue);
          } else if (newValue < this.minValue) {
            newValue = this.minValue;
            this.currentValueFormControl.setValue(newValue);
          }
        }
        this.notifyValueUpdated(newValue);
      },
    );
  }

  public isRequired(): boolean {
    return !this.required ? false : this.required;
  }

  public onIncrementValueClick(): void {
    const curValue = this.currentValueFormControl.value as number;
    if (curValue === null) {
      this.currentValueFormControl.setValue(this.minValue);
    }
    if (curValue >= this.maxValue) {
      return;
    }
    this.currentValueFormControl.setValue(curValue + 1);
  }

  public onDecrementValueClick(): void {
    const curValue = this.currentValueFormControl.value as number;
    if (curValue === null) {
      this.currentValueFormControl.setValue(this.minValue);
    }
    if (curValue <= this.minValue) {
      return;
    }
    this.currentValueFormControl.setValue(curValue - 1);
  }

  private notifyValueUpdated(value: number | null): void {
    if (this.emitNewValue) {
      this.valueUpdated.emit(value);
    }

    this.currentValueFormControl.markAsDirty();
  }

  private setId() {
    this.Id = `${this.baseId}-numeric-up-down`;
  }
}
